"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var scapholdAuthTokenStorageKey = exports.scapholdAuthTokenStorageKey = "CodogoScapholdAuth";
var accountURL = exports.accountURL = "https://account.codogo.io";

var scapholdDomain = "eu-west-1.api.scaphold.io";
var scapholdURL = exports.scapholdURL = "https://" + scapholdDomain + "/graphql/codogo";
var scapholdSubURL = exports.scapholdSubURL = "wss://" + scapholdDomain + "/graphql/codogo";

//# sourceMappingURL=consts.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/consts.js
// module id = 133
// module chunks = 0